import { useEffect, useState } from 'react';

// img
import isotipo from './Images/IsotipoBlanco.png';

// components
import NuevoAsesor from './Pages/NuevoAsesor/NuevoAsesor';
import LogIn from './Pages/LogIn/LogIn';
import StepBtn from './Components/StepBtn/StepBtn';

// prime react
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';

// styles
import "./Styles/AppLayout.scss"

function App() {
  // Form functionality states
  const [stepCounter, setStepCounter] = useState(0)
  const [ableNextStep, setAbleNextStep] = useState(false)



  // Login Data
  const [asesorData, setAsesorData] = useState({
    asesorCua: "",
    asesorName: "",
    asesorPhone: "",
    asesorEmail: ""
  })





  // Props packs
  const StepsProps = {
    stepCounter, setStepCounter, 
    ableNextStep, setAbleNextStep
  }
  const AsesorProps = {
    asesorData, setAsesorData
  }






  // PRIME REACT español
  useEffect
  (() => {
    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Limpiar',
      //...
    });    
    locale('es');
  }, [])  






  return (<div className="appLayout">
    <div className="bg-overlay"/>
    
    <header className="Header" onClick={()=> window.location.href = "."}><img src={isotipo}/></header>
    
      <main className="App">

        <StepBtn disabled={true} {...StepsProps} direction="left" />









        {/* 0 is for the Login Form */}
        {/* 1 is for waiting a response to the auth api */}
        {stepCounter < 2 && <LogIn {...AsesorProps} {...StepsProps} />}
        
        {/* 2 es para el Form del Nuevo Asesor */}
        {stepCounter >= 2 && <NuevoAsesor {...AsesorProps} />}









        {/* cuando llego al formulario del nuevo asesor oculto este botón porque allá uso el de enviar, no este (hice otro en <NuevoAsesor />) */}
        {
          stepCounter < 2 &&
          <StepBtn disabled={!ableNextStep} {...StepsProps} direction="right" />
        }







        <div className="mobile-actions">
          <StepBtn disabled={true} {...StepsProps} direction="left" />
          <StepBtn disabled={!ableNextStep} {...StepsProps} direction="right" />
        </div>

      </main>
  </div>
  );
}

export default App;
